module.exports = __webpack_public_path__ + "68bdc27ad6fda220042385a820f8166d.png";